module.exports = __webpack_public_path__ + "static/img/step1.8963567d.jpg";